module.exports = __webpack_public_path__ + "668ff42f535019c68238b39234090386.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/velikonocni-tabor-1.jpg
// module id = 1201
// module chunks = 0